<div class="slider">
    <button class="slider-prev-btn" (click)="prev()" [disabled]="index === 0">‹</button>
    <div
        class="slider-body"
        #win
        (mousedown)="onStart($event.clientX)"
        (mousemove)="onMove($event.clientX)"
        (mouseup)="onEnd()"
        (mouseleave)="onEnd()"
        (touchstart)="onStart($event.touches[0].clientX)"
        (touchmove)="onMove($event.touches[0].clientX)"
        (touchend)="onEnd()"
    >
        <div
            class="slider-body-track"
            [style.transform]="'translateX(' + translateX + 'px)'"
            [class.no-transition]="dragging"
            [style.gap.px]="gap"
        >
            <ng-content></ng-content>
        </div>
    </div>
    <button class="slider-next-btn" (click)="next()" [disabled]="index >= max">›</button>
</div>
